import { type FC } from 'react'
import { Col, Container, Row, Tab } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { Tabs } from '../../components/Tabs/Tabs'
import { useZocksAuth } from '../../components/ScopedBlock/hooks'
import { type PageMetadata } from '../../models/PageMetadata'
import { InviteUserActions } from './InviteUserActions'
import { PendingInvitationsTab } from './PendingInvitations/PendingInvitationsTab'
import { TeamMembersTab } from './TeamMembersTab'
import { TEAM_TABS } from './teamTabs'

interface TeamMembersTabsProps {
  usersPage: PageMetadata | undefined
}

export const TeamMembersTabs: FC<TeamMembersTabsProps> = ({ usersPage }) => {
  const { activeTab = null } = useParams()
  const selectedTab = activeTab && TEAM_TABS.includes(activeTab) ? activeTab : null
  const { hasScope } = useZocksAuth()
  const hasInviteScope = hasScope('**', 'consoleuser:invite', ['consoleuser:admin'])
  const navigate = useNavigate()

  const changeTab = (key: string | null) => {
    if (key) {
      navigate(`/account/manage-team/${key}`, { replace: true })
    }
  }

  return (
    <Container className='p-0'>
      <Row className='mb-6'>
        <Col>
          <InviteUserActions usersPage={usersPage} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs className='mb-4' defaultActiveKey={selectedTab || undefined} onSelect={changeTab} id='manage-team-tabs' activeKey={selectedTab || undefined}>
            <Tab eventKey='members' id='Members' title='Members'>
              <TeamMembersTab />
            </Tab>
            {hasInviteScope ? (
              <Tab eventKey='pending-invitations' id='Pending Invitations' title='Pending Invitations'>
                <PendingInvitationsTab />
              </Tab>
            ) : null}
          </Tabs>
        </Col>
      </Row>
    </Container>
  )
}
